import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withPaginate from 'shared/hocs/withPaginate';
import s from './Paginate.css';

class Paginate extends React.Component {
  static propTypes = {
    pageCount: PropTypes.number.isRequired,
    initialPage: PropTypes.number,
    backgroundColor: PropTypes.string,
    pageRangeDisplayed: PropTypes.number,
    overallCount: PropTypes.number,
    intl: intlShape.isRequired,
    hrefBuilder: PropTypes.func.isRequired,
    pageChanger: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialPage: 1,
    pageRangeDisplayed: 2,
    overallCount: 0,
    backgroundColor: '',
  };

  render() {
    const {
      pageCount,
      initialPage,
      pageRangeDisplayed,
      hrefBuilder,
      pageChanger,
      overallCount,
      backgroundColor,
      intl,
    } = this.props;
    const prevClassName = initialPage === 1 ? s.hidden : s.previous;
    const nextClassName = initialPage === pageCount ? s.hidden : s.next;

    return (
      <div className={s.root}>
        <div>
          <ReactPaginate
            pageCount={pageCount}
            pageRangeDisplayed={pageRangeDisplayed}
            initialPage={initialPage - 1}
            previousLabel={intl.formatMessage({ id: 'Предыдущая' })}
            nextLabel={intl.formatMessage({ id: 'Следующая' })}
            breakLabel="..."
            disableInitialCallback
            onPageChange={pageChanger}
            hrefBuilder={hrefBuilder}
            breakClassName={s.breakMe}
            containerClassName={s.pagination}
            previousClassName={prevClassName}
            nextClassName={nextClassName}
            activeClassName={backgroundColor || s.activePage}
            subContainerClassName={''}
            pageClassName={s.pageItem}
          />
        </div>
        {overallCount > 0 &&
          <div>
            <FormattedMessage id="Всего" />: <strong>{overallCount}</strong>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({ locale: globals.locale });

export default withStyles(s)(injectIntl(connect(mapStateToProps)(withPaginate(Paginate))));



// WEBPACK FOOTER //
// ./src/desktop/components/Paginate/Paginate.js